import React, { Component } from 'react';
import cookie from 'react-cookies';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import { toast } from 'react-toastify';
import {hideNav, showLoader, hideLoader, configureMoment} from '../../../functions';
import Moment from 'moment';
import $ from 'jquery';
export default class FichaPais extends Component {
    state = {
        fichasPais: [],
        pagina: 1,
        totalPages: 0
    }

    EstadoText(value)
    {
        switch(value)
        {
            case "0": return <span className="label label-primary">Borrador</span>;
            case "1": return <span className="label label-info" style={{background: "#44AA44"}}>Publicado</span>;
            default: break;
        }
    }
  
    render() {
        configureMoment(Moment);

        return (
            <div>
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de Configuración General
                        </a>
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Ficha de Mercado</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Ficha de Mercado
                </div>
                <div className="divSector_Panel">
                    {/* <div className="divCatAnadir_Panel">
                        <a href="#" className="btnAnadirCat noneEvent" onClick={() => this.addFichaPais()}>AÑADIR</a>
                        <div className="divSectorSearch_Panel">
                        <input type="text" placeholder="Encontrar ficha país..." id="busqueda" onKeyDown={this._handleKeyDown}/>
                        <input type="submit" defaultValue="Buscar" onClick={(event) => this.callFunctionBuscar(event)}/>
                        </div>
                        <div className="clear" />
                    </div> */}
                    <div className="divCatAnadir_Panel">
                    <div className="body-container container-fluid">
                        <div className="input-group">
                            <div className="input-group col-sm-7">
                            <i className="recursos__search-icon fas fa-search"></i>
                            <input className="recursos__search-form-control form-control input-lg" type="text" placeholder="Digite un mercado..." id="busqueda" onKeyDown={this._handleKeyDown}/>
                            </div>
                            <div className='input-group-btn'>
                            <a href="#" className="btn btn-primary btn-primary__submit noneEvent" onClick={(event) => this.callFunctionBuscar(event)}>
                                <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                BUSCAR
                                </a>
                            </div>
                            &nbsp;&nbsp;
                            {/* <div className='input-group-btn'>
                            <a href="#" className="btn btn-success btn-primary__submit noneEvent" onClick={() => this.addFichaPais()}>
                                <i className="fa fa-save" style={{ marginRight: "8px" }} />
                                NUEVO
                            </a> 
                            </div> */}
                        </div>
                    </div>
                    </div>
                    <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <th>N°</th>
                                <th>Código</th>
                                <th>Continente</th>
                                <th>Descripción de Mercado</th>
                                <th>Estado</th> 
                                <th width={"100"}>Acciones</th>
                            </tr>
                                {
                                    this.state.fichasPais.length > 0 ? 
                                    
                                    this.state.fichasPais.map((item, index) => (
                                        <tr key={`pais-codigo-${item.paisCodigo}`}>
                                            <td>{(index + 1) + ((this.state.pagina - 1) * 10)}</td>
                                            <td>{item.celdaValor1}</td>
                                            <td>{item.celdaValor2}</td>
                                            <td>{item.nombrePais}</td>
                                            {/* <td>{Moment(item.fechaCreacion).format('DD/MM/YYYY HH:mm A')}</td>*/}
                                            <td>{this.EstadoText(item.estado)}</td> 
                                            <td>
                                                <div className="divBtnAcciones px-3" style={{ 'width': 100 }}>
                                                    {/* <a href="#" className="btnListIcon" title="Consejeros" onClick={(event) => this.irMantConsejeros(event, item.paisCodigo)} /> */}
                                                    {/* <a href="#" className={item.estado == "1" ? "btnPageModuloInactivo" : "btnPageModuloVer"} onClick={(event) => this.actualizarEstado(item, event)}/> */}
                                                    {/* <a href="#" className="btnPageModuloEditar" onClick={(event) => this.editFichaPais(item.paisCodigo)}/> */}
                                                    <button
                                                     type="button"  
                                                     className="btn btn-primary btn-sm btn-primary__tool" 
                                                     onClick={(event) => this.editFichaPais(item.paisCodigo)}
                                                     >
                                                        <i className="fas fa-pen fa-sm"></i>
                                                    </button>
                                                    
                                                    {/* <a href="#" className="btnPageModuloEliminar aEliminarMenu2"/>
                                                    <div className="c_divAlertaCapa">
                                                        <div className="divAlertaCapa">
                                                            <div className="divAlerta">
                                                                <h2>&iquest;Seguro de eliminar?</h2>
                                                                <div className="divAlertaBtn">
                                                                    <a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarRegistro(item, event)}>ACEPTAR</a>
                                                                    <a href="#" className="btnAlertaCancelar">CANCELAR</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    (
                                        <tr>
                                            <td colSpan="5" className="tdSinResultados">
                                                No se encontró resultados.
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                    {this.paginationTable()}
                    <div className="clear" />
                </div>
            </div>
        )
    }

    irMantConsejeros(event, id){
        event.preventDefault();
        this.props.history.push({
            pathname: '/ficha-pais-consejeros/' + id
        });
    }

    ShowPaginationFive(pagina)
	{
        if(this.state.totalPages == 1 || this.state.totalPages == 0){
            return;
        }
        
		$(".divPaginador a.active").removeClass("active");
		$(".divPaginador a:eq("+pagina+")").next().addClass("active");
		$(".divPaginador .pageItem").hide();
		
		let id = $(".divPaginador a.active").prop("id");
        let ItemPage = parseInt(id.replace('paginado-', ''));
        
		if(ItemPage < 4)
		{
			$(".divPaginador .pageItem").slice(0,5).show();
		}
		else if(ItemPage < 5)
		{
			$(".divPaginador .pageItem").slice(1,6).show();
		}
		else if(ItemPage < 6)
		{
			$(".divPaginador .pageItem").slice(2,7).show();
		}
		else if(ItemPage >= 6)
		{
			$(".divPaginador .pageItem.active").prev().prev().show();
			$(".divPaginador .pageItem.active").prev().show();
			$(".divPaginador .pageItem.active").show();
			$(".divPaginador .pageItem.active").next().show();
			$(".divPaginador .pageItem.active").next().next().show();
		}
		
		if(!$(".pageItem.active").next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().show()
		  }
		}
		if(!$(".pageItem.active").next().next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().prev().show()
		  }
		}
    }

    executePaginationPrev(e)
	{
		if(!$(".divPaginador a.active").prev().hasClass("btnPrevPaginador"))
		{
            let id = $(".divPaginador a.active").prop("id");
            let itemPage = parseInt(id.replace('paginado-', '')) - 1;
			this.executePagination(itemPage, e);
		}
	}
	
	executePaginationNext(e)
	{
		if(!$(".divPaginador a.active").next().hasClass("btnNextPaginador"))
		{
            let id = $(".divPaginador a.active").prop("id");
            let itemPage = parseInt(id.replace('paginado-', '')) + 1;
            
			this.executePagination(itemPage, e);
		}
	}

    executePagination(page)
    {
        const url = this.getURL(page);
        for(let index=0; index < this.state.totalPages+2; index++)
        {
			if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }
        
		if($("#"+page).is("*"))
        {
			document.getElementById(page).classList.add("active");
        }

        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            this.setState({ 
                fichasPais: data.result.data.Data, 
                pagina: page,
                totalPages: data.result.data.TotalPages
            });
            this.ShowPaginationFive(page-1);
        })
        .catch(error => {
            toast.error('Error al listar');
        });
    }

    paginationTable()
    {
        const options = [];
        if(this.state.totalPages == 1 || this.state.totalPages == 0){
            return;
        }

        options.push(<a className="btnPrevPaginador" id={`paginado-prev`} key={`paginado-prev`} onClick={() => this.executePaginationPrev()}></a>);
            
        for(let index=1; index <= this.state.totalPages; index++){
            options.push(<a className="pageItem" id={`paginado-${index.toString()}`} key={`paginado-${index.toString()}`} onClick={() => this.executePagination(index)}> {index} </a>);
        }
     
        options.push(<a className="btnNextPaginador" id={`paginado-next`} key={`paginado-next`} onClick={() => this.executePaginationNext()}></a>)

        return (
            <div className="divPaginador">
                {options}
            </div>
        );
    }

    addFichaPais(){
        this.props.history.push({
            pathname: '/agregar-ficha-pais'
        });
    }

    editFichaPais(id){
        this.props.history.push({
            pathname: '/editar-ficha-pais/' + id
        });
    }

    actualizarEstado(fichaPais, event){
        event.preventDefault();
        const url = `${API_URL}FichaPaisUX/ActualizarEstado`;
        fichaPais["UsuarioEdicion"] = cookie.load('user').nUsuCodigo;
        axios.post(url, JSON.stringify(JSON.stringify(fichaPais)),
        { 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then((data) => {     
            if (data.data.result.status)
            {
                setTimeout(() => { 
                    this.executePagination(this.state.pagina);
                }, 500);  
            }
        }).catch((error)=> {
            
        });  
    }
    
    eliminarRegistro(fichaPais, event) {
        event.preventDefault();
        const url = `${API_URL}FichaPaisUX/Eliminar`;
        fichaPais["UsuarioEliminacion"] = cookie.load('user').nUsuCodigo;

        axios.post(url, JSON.stringify(JSON.stringify(fichaPais)),
        { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
        }
        }).then((data)=> {
            if (data.data.result.status)
            {
                setTimeout(() => { 
                    this.executePagination(this.state.pagina);
                }, 500);  
            }
        }).catch((error)=> {
        });
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.callFunctionBuscar(e);
        }
    }

    callFunctionBuscar = (event) => {
        showLoader();

        const url = this.getURL(1);
        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            hideLoader();
           
            this.setState({ 
                fichasPais: data.result.data.Data, 
                pagina: 1,
                totalPages: data.result.data.TotalPages
            });
            this.ShowPaginationFive(0);
        })
        .catch(error => {
            hideLoader();
            toast.error('Error al listar');
        });
    }

    getURL(pageRequest){
        return `${API_URL}FichaPaisUX/Listar?page=${pageRequest}&busqueda=` + document.getElementById('busqueda').value;
    }

    componentDidMount(){
        showLoader();

        const url = this.getURL(1);
        axios.get(url)
            .then(response => response.data)
            .then((data) => {
                hideLoader();
                this.setState({ 
                    fichasPais: data.result.data.Data, 
                    pagina: 1,
                    totalPages: data.result.data.TotalPages
                });
                this.ShowPaginationFive(0);
            })
            .catch(error => {
                hideLoader();
                toast.error('Error al listar');
            });
    }
}
